module.exports = __webpack_public_path__ + "media/images/icon_ul3-72abe5cf17e25ebb3c7940a833e08e9e.svg";